import React from "react";
import Banner from "../components/Banner";
import ExploreSection from "../components/ExploreSection";
import AppDownloadSection from "../components/AppDownloadSection";
import QualityServices from "../components/QualityServices";
// import Services from "../components/Services";
// import PetsStatistics from "../components/PetsStatistics";

const Home = () => {
  return (
    <>
    <Banner/>
    <ExploreSection/>
    {/* <PetsStatistics/> */}
    <AppDownloadSection/>
    <QualityServices/>
    {/* <Services/> */}
    </>
  );
};

export default Home;
